import api from "../../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    Employees: [], PersonDoc:[]
  },
  getters: {
    getEmployees(state) {
      return state.Employees;
    },getPersonDoc(state) {
      return state.PersonDoc;
    },
  },
  mutations: {
    SetEmployees(state, data) {
      state.Employees = [];
      state.Employees = data;
    },SetPersonDoc(state, data) {
      state.PersonDoc = [];
      state.PersonDoc = data;
    },
  },
  actions: {
    fetchAllEmployees({ commit }) {
      return new Promise((resolve, rej) => {
      api()
        .post(
          `Employees/get_all_Employees`,
          {},
          {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
        )
        .then((res) => {
                      resolve(res);

          commit("SetEmployees", res.data);
        })
        .catch((err) => console.log(err));});
    },

    getEmployeeById({ commit },id) {
      return new Promise((resolve, rej) => {
      api()
        .post(
          `Employees/getEmployeeById`,
          {id:id},
          {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
        )
        .then((res) => {
                      resolve(res);

          commit("SetEmployees", res.data);
        })
        .catch((err) => console.log(err));});
    },

    
    fetchpersonDocBypersonID({ commit }, id) {
      return new Promise((resolve, rej) => {
      api()
        .post(
          `Employees/get_personDoc_by_personID`,
          {
            id: id,
          },
          {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
        )
        .then((res) => {
          resolve(res);
          commit("SetPersonDoc", res.data);
        })
        .catch((err) => console.log(err));});
    },



    addEmployee({ }, formData) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Employees/add_Employee`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',

                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    editEmployee(
      { },
      formData
    ) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Employees/edite_Employee`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',

                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);

          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },

    deleteEmployee({ }, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Employees/delete_Employee`,
            { id: id },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);

          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },

    UploadCaptionFile({ }, Formdata) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Employees/UploadEmployeeFile`,
            Formdata,
            {
              headers: {
                'Content-Type': 'multipart/form-data',

                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },






    
    removeCaptionFile({ }, {EmployeesId,docNameId}) {
  return new Promise((resolve, rej) => {
    api()
      .post(
        `employees/removeEmployeeFile`,
        { docNameId: docNameId,EmployeesId:EmployeesId },
        {
          headers: {
            Authorization: localStorage.getItem("JwtToken"),
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        resolve(err.response);
      });
  });
},




    
  },
};
